import React from 'react'
import {
  DesignedModal,
  Button,
  ButtonWithIcon,
  useTriggerOnPressEnter,
} from '@clickcease/cc-client-components-lib'
import { Trash } from 'Assets/icons/Trash'
import { useTranslation } from 'react-i18next'

interface ConfirmationModalProps {
  isOpen?: boolean
  onOpenChange: (a: boolean) => void
  title: string
  ctaText: string
  cancelText?: string
  description: string
  loading?: boolean
  ctaAction: () => void
}

export const ConfirmationModal = ({
  isOpen,
  onOpenChange,
  title,
  description,
  ctaText,
  cancelText,
  loading,
  ctaAction,
}: ConfirmationModalProps) => {
  const { t } = useTranslation('domainManagement')
  useTriggerOnPressEnter(ctaAction)

  return (
    <DesignedModal
      title={title}
      text={description}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      style={{ width: '500px' }}
      actions={
        <>
          <Button
            variant="ghost"
            text={cancelText ? cancelText : t('add_new_domain_modal.cancel')}
            onClick={() => {
              onOpenChange(false)
            }}
          />
          <ButtonWithIcon
            iconLeft={<Trash />}
            text={ctaText}
            loading={loading}
            onClick={() => {
              ctaAction()
            }}
          />
        </>
      }
    />
  )
}
